module.exports = __webpack_public_path__ + "img/Character_Nilou_Thumb.91b195dc.png";